module.exports = __webpack_public_path__ + "img/image-error-404.d26e5bc6.jpg";